<template>
  <div class="app">
    <label style="padding: 5px; color: #424242;">Период отбора проб</label>
    <div style="padding-top: 2px">
      <VueHotelDatepicker
        ref="VueHotelDatepicker"
        class="VueHotelDatepicker"
        :selectForward = "true"
        mobile = "mobile"
        :weekList="weekList"
        :fromText="fromText"
        :toText="toText"
        :confirmText="confirmText"
        :separator="separator"
        :format="format"
        :resetText="resetText"
        :placeholder="selectedStart +' - ' + selectedEnd"
        :monthList="monthList"
        :startDate="convertDateForPicker(today)"
        :endDate="convertDateForPicker(today)"
        minDate="2022/01/01"
        :maxDate="new Date()"
        @close="close"
        @confirm="sendToMap"
      />
      <a v-on:click="sendToMapToday()" class="today">Сегодня</a>
      <span style="padding: 5px;">{{ messeage }}</span>
    </div>
  </div>
</template>

<script>
import VueHotelDatepicker from "/src/plugins/vue-datepicker";
import { bus } from "../main";
export default {
  components: { VueHotelDatepicker },
  data() {
    return {
      messeage: "",
      today: "",
     
      selectedStart: "",
      selectedEnd: "",
      fromText: "От",
      toText: "До",
      resetText: "Отменить",
      separator: "-",
      format: "DD.MM.YYYY",
      confirmText: "Выбрать",
      weekList: ["Пон.", "Втр.", "Сре.", "Чет.", "Пят.", "Суб.", "Вос."],
      monthList: [
        "Янв.",
        "Феф.",
        "Мар.",
        "Апр.",
        "Май",
        "Июнь",
        "Июль",
        "Авг.",
        "Сен.",
        "Окт",
        "Ноя.",
        "Дек.",
      ],
    };
  },
  methods: {
    close() {
      this.$refs.VueHotelDatepicker.reset();
    },
    getToDay() {
      this.today = new Date().toLocaleDateString();
    },
    convertDateForPicker: function (date) {
      let newStr = date.split(".");
      return newStr[2] + "/" + newStr[1] + "/" + newStr[0];
    },
    sendToMapToday() {
      this.$refs.VueHotelDatepicker.reset();
      this.sendToMap({ start: this.today, end: this.today });
    },
    sendToMap(selectedDates) {
      this.selectedStart = selectedDates.start ;
      this.selectedEnd= selectedDates.end;
      bus.$emit("selected-date", selectedDates);
    },
  },
  mounted() {
    this.sendToMap({ start: this.today, end: this.today });
    
  },
  created() {
    this.getToDay();
    bus.$on("samples-is-empty", (messeage) => { 
      this.messeage = messeage;
    });
     bus.$on("samples-is-not-empty", (messeage) => { 
         this.messeage = messeage;
    });
  },
};
</script>
<style scoped>
.app {
  position: relative;
   padding: 12px;
}
.VueHotelDatepicker {
 border: 1px solid #aaa; 
 margin-bottom: 15px; margin-right: 10px;
 border-radius: 5px;
 background: #f2f9e9;
}
a.today {
  font-weight: 700;
  color: white;
  text-decoration: none;
  padding: 0.8em 1em calc(0.8em + 1px);
  border-radius: 3px;
  background: #98bc69;
  transition: 0.2s;

}
a.today:hover {
  background: #a5c975;
}
a.today:active {
  background: #aece83;
  box-shadow: 0 4px #98bc69 inset;
}
</style>